'use strict';

class FotosComputosController {
  constructor(DataService, Modal, $scope,$log) {
    'ngInject';

    this.DataService = DataService;
    this.Modal = Modal;
    this.$scope = $scope;
    this.$log=$log;
  }

  $onInit() {
    this.initConfiguracion();
    this.$scope.$on('recargarFotos', () => {
      this.initConfiguracion();
    });
  }

  initConfiguracion() {
    this.fotos = {
      backups: {},
      uploadCallback: (file) => {
        var data = angular.copy(file);
        data.fid_supervision = this.supervision.id_supervision;
        data.fid_item = this.item.id_item;
        data.tipo = 'TF_EMPRESA';
        data.path_fotografia = data.name + '_' + data.nombre.replace(/\s/,'_');
        if (this.fotos.backups[file.name]) {
          data.id_foto_supervision = this.fotos.backups[file.name].id_foto_supervision;
          data.id = data.id_foto_supervision;
        }
        this.$log.log('data============Foto>' + JSON.stringify(data));
        this.DataService.save(`fotos`, data).then(response => {
          if(response&&response.finalizado) {
            if(response.datos.path_fotografia.indexOf('.pdf')>0) {
              let cod = `CMPDF_${response.datos.path_fotografia}`, id=this.supervision? this.supervision.fid_proyecto:0;
              this.urlViewBase64 = id? `proyectos/${id}/doc/${cod}` : '';
              this.urlDownloadBase64 = id? `proyectos/${id}/doc/${cod}/descargar` : '';
            }
          }
          this.fotos[file.name] = {
            id_foto_supervision: response.datos.id_foto_supervision,
            base64: data.base64,
            nombre: data.nombre.replace(/\s/,'_'),
            show: true,
            showImage: true
          }
          //guardamos backup para recuperar el id_foto_supervision
          this.fotos.backups[file.name] = angular.copy(this.fotos[file.name]);
        })
        this.$log.log('ENTRA AQUI===========>')
      }
    };
  }

  showImage(key) {
    var foto = this.fotos[key];
    if (foto.base64) {
      foto.showImage = !foto.showImage;
    } else {
      if(foto.nombre.indexOf('.pdf')>0) {
        let cod = `CMPDF_${foto.codigo}_plano_${foto.nombre}`, id=this.supervision? this.supervision.fid_proyecto:0;
        this.urlViewBase64 = id? `proyectos/${id}/doc/${cod}` : '';
        this.urlDownloadBase64 = id? `proyectos/${id}/doc/${cod}/descargar` : '';
        foto.showImage = true;
        foto.show = true;
      } else {
        this.DataService.get(`fotos/${foto.id_foto_supervision}`).then(response => {
          foto.base64 = response.datos;
          foto.showImage = true;
          foto.show = true;
        })
      }
    }
  }

  changeImage(key) {
    var foto = this.fotos[key];
    if (foto.show) {
      this.Modal.confirm('¿Está seguro/a de cambiar la imagen?', () => {
        foto.show = false;
      }, null, null, 'Sí, estoy seguro/a', 'Cancelar');
    } else {
      foto.show = true;
    }
  }

  vistaPrevia() {
    if (this.fotos['plano'].base64) {
      this.Modal.showDocumentBase64(this.fotos['plano'].base64, this.label, 'strBase64');
    }
  }

  vistaImagen(imgData) {
    if (imgData.base64) {
      this.Modal.showImageBase64(imgData, null);
    }
  }
}

export default FotosComputosController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/computo-proyecto/fotos/fotos.controller.js